import React from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import { Close, Coin, CoinIcon } from './../block/Svg'

/**
 * Статусы заказов
 * new - в обработке
 * sent - в обработке
 * error - отменен
 * jupiter_new - в обработке
 * cancelled - отменен
 * preparing - готовим
 * ready - готов
 * ontheway - у курьера
 * delivered - доставлен
 */

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      statuses: {
        new: {
          image: 1,
          rimage: `image1.png`,
          name: `В обработке`,
          text: `Скоро начнем готовить заказ`,
          color: `#5A91FF`
        },
        sent: {
          image: 1,
          rimage: `image1.png`,
          name: `В обработке`,
          text: `Скоро начнем готовить заказ`,
          color: `#5A91FF`
        },
        error: {
          image: 2,
          rimage: `image2.svg`,
          name: `Заказ отменен`,
          text: `Упс, что-то пошло не так`,
          color: `#3A3A3A`
        },
        jupiter_new: {
          image: 1,
          rimage: `image1.png`,
          name: `В обработке`,
          text: `Скоро начнем готовить заказ`,
          color: `#5A91FF`
        },
        cancelled: {
          image: 2,
          rimage: `image2.svg`,
          name: `Заказ отменен`,
          text: `Упс, что-то пошло не так`,
          color: `#3A3A3A`
        },
        preparing: {
          image: 3,
          rimage: `image3.svg`,
          name: `Готовим для вас`,
          text: `Заказ готовится к отправке`,
          color: `#5A91FF`
        },
        ready: {
          image: 4,
          rimage: `image4.svg`,
          name: `Заказ готов`,
          text: `Передаем в доставку курьером`,
          color: `#F66116`
        },
        ontheway: {
          image: 5,
          rimage: `image5.svg`,
          name: `Заказ у курьера`,
          text: `Мы позвоним по прибытии`,
          color: `#A6DD2F`
        },
        delivered: {
          image: 6,
          rimage: `image6.svg`,
          name: `Заказ доставлен`,
          text: `Приятного аппетита!`,
          color: `#A6DD2F`
        },
        pending: {
          image: 1,
          rimage: `image1.png`,
          name: `Заказ не создан`,
          text: `Повторите оплату`,
          color: `#868686`
        }
      }
    }
  }

  showModal = () => {
    this.setState({
      modal: true
    })
  }
  closeModal = () => {
    this.setState({
      modal: false
    })
  }

  repeatOrder = () => {
    const main = this,
    { order, data } = this.props

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'repeat_order',
      id: order?.id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if(response?.data?.result) window.location = data?.cart_link
    })
    .catch((error) => {
      console.error('Ошибка запроса:', error);
    })
  }

  render() {
    const { order, user, restaurant, assets_path } = this.props,
    { statuses, modal } = this.state

    var status = order?.status
    if(status == `new` && order?.payment_status == 'pending') status = `pending`

    if(order?.number != ``) return (
      <>
        <div
          className='w-[100%] overflow-x-hidden bg-cover bg-center bg-no-repeat tracking-tighter flex justify-center'
          style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
        >
          <div className='container font-manrope tracking-tight min-h-dvh flex flex-col'>
            <div class="flex items-center justify-between pt-[10px] relative z-[1]">
              <a href='/' class="flex-none w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center cursor-pointer">
                <Close />
              </a>
              <div className='flex-none flex items-center justify-center flex-col'>
                <Coin />
                <div className='w-[35px] h-[15px] bg-[#A6DD2F] flex gap-[2px] items-center justify-center rounded-full mt-[-8px] z-10'>
                  <div className='text-white text-[10px]'>{user?.coin}</div>
                  <CoinIcon />
                </div>
              </div>
            </div>
            <div className='flex justify-center w-[100%] mt-[-12px] mb-[15px]'>
              <img src={`/${assets_path}/images/plashki/bigimg.svg`} width='165' height='175' alt='okidoki' />
            </div>
            <div className='text-center font-semibold text-[22px] text-black'>№{order?.number}</div>
            <div className='text-center text-[18px] text-[#00000099] mb-[45px]'>Номер заказа</div>
            <div
              className={`bg-cover bg-center rounded-t-[25px] ml-[-10px] w-[calc(100%+20px)] overflow-hidden mt-auto`}
              style={{ backgroundImage: `url('/${assets_path}/images/statusPlashka.svg')`, backgroundColor: statuses[status]?.color }}
            >
              <div className='rounded-[25px] w-[100%] h-[129px] pb-[43px] flex items-center px-[15px] gap-[10px]'
                style={{ background: `url('/${assets_path}/images/plashki/${statuses[status]?.rimage}') no-repeat calc(100% - 20px) 10px`, backgroundSize: `120px` }}
              >
                <img src={`/${assets_path}/images/plashki/icon${statuses[status]?.image}.svg`} />
                <div>
                  <div className='text-white text-[22px] font-semibold'>{statuses[status]?.name}</div>
                  <div className='flex gap-[5px] items-center text-[#FFFFFF99] text-[14px]'>
                    <div>{statuses[status]?.text}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='mh-[100px] ml-[-10px] w-[calc(100%+20px)] mt-[-43px] bg-white rounded-t-[25px] p-[15px] pt-[20px]'>
              <div className='text-center text-[22px] mb-[10px] text-black font-semibold'>Детали заказа</div>
              {status != 'delivered' &&
                <a href={`tel:${restaurant?.phone}`} className='bg-[#F6F6F6] h-[40px] rounded-full flex items-center justify-between p-[5px] mb-[15px]'>
                  <div className='w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center'>
                    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} fill="none">
                      <path
                        fill="#767676"
                        stroke="#767676"
                        strokeMiterlimit={10}
                        d="M15.562 12.984c0 .255-.056.517-.177.772-.12.255-.276.496-.481.722-.347.383-.73.66-1.162.836-.425.177-.885.27-1.381.27-.723 0-1.495-.17-2.31-.518a12.442 12.442 0 0 1-2.436-1.402 20.362 20.362 0 0 1-2.323-1.983 20.132 20.132 0 0 1-1.977-2.317A12.628 12.628 0 0 1 1.927 6.95c-.34-.808-.51-1.58-.51-2.316 0-.482.085-.942.255-1.368.17-.432.44-.828.815-1.182.453-.447.949-.666 1.473-.666.198 0 .397.042.574.127.184.085.347.213.474.397l1.644 2.316c.127.177.22.34.283.496.064.149.1.298.1.432 0 .17-.05.34-.15.503a2.41 2.41 0 0 1-.396.503l-.539.56a.379.379 0 0 0-.113.283c0 .056.007.106.021.163.021.056.043.099.057.141.127.234.347.539.659.907.318.368.658.744 1.027 1.12.382.375.75.722 1.126 1.04.368.312.673.525.914.652.035.014.078.036.127.057a.488.488 0 0 0 .177.028.39.39 0 0 0 .29-.12l.54-.531c.176-.178.346-.312.51-.397a.943.943 0 0 1 .502-.149c.135 0 .276.028.432.092.156.064.319.156.496.276l2.345 1.665c.184.127.311.276.39.453.07.177.112.355.112.553Z"
                      />
                      <path
                        stroke="#767676"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13.104 6.375c0-.425-.333-1.077-.829-1.608-.453-.489-1.055-.871-1.65-.871M15.583 6.375a4.955 4.955 0 0 0-4.958-4.958"
                      />
                    </svg>
                  </div>
                  <div className='text-black text-[16px] font-medium'>
                    {status == 'ontheway' ?
                      <>Связаться с курьером</>
                    :
                      <>Связаться с менеджером</>
                    }
                  </div>
                  <div className='w-[30px] h-[30px]' />
                </a>
              }
              <div className='relative mb-[15px]'>
                <div className='absolute top-[20px] bottom-[20px] left-[19px] border-r-[1px] border-dashed border-[#0000004D] z-[1]' />
                <div className='flex items-center gap-[8px] mb-[16px] relative z-[2]'>
                  <div className='w-[40px] h-[40px] rounded-full bg-[#eff4ff] flex items-center justify-center flex-none'>
                    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
                      <path
                        stroke="#5A91FF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        d="M1.667 18.333h16.667"
                      />
                      <path
                        stroke="#5A91FF"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        d="M2.458 18.334 2.5 8.309c0-.509.241-.992.641-1.309L8.975 2.46a1.676 1.676 0 0 1 2.05 0l5.833 4.533c.408.317.642.8.642 1.317v10.025"
                      />
                      <path
                        stroke="#5A91FF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        d="M12.916 9.167H7.083c-.692 0-1.25.558-1.25 1.25v7.916h8.333v-7.916c0-.692-.558-1.25-1.25-1.25ZM8.333 13.542v1.25M8.75 6.25h2.5"
                      />
                    </svg>
                  </div>
                  <div>
                    <div className='text-[14px] text-[#00000099]'>Адрес заказа</div>
                    <div className='text-black font-semibold text-[18px]'>{order?.address}</div>
                  </div>
                </div>
                <div className='flex items-center gap-[8px] mb-[16px] relative z-[2]'>
                  <div className='w-[40px] h-[40px] rounded-full bg-[#eff4ff] flex items-center justify-center flex-none'>
                    <svg xmlns="http://www.w3.org/2000/svg" width={19} height={19} fill="none">
                      <path
                        stroke="#5A91FF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9.5 6.44v3.648l1.83 1.831"
                      />
                      <path
                        stroke="#5A91FF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M1 9.5A8.5 8.5 0 0 1 9.5 1 8.5 8.5 0 0 1 18 9.5a8.511 8.511 0 0 1-3.27 6.709h-.012A8.425 8.425 0 0 1 9.5 18a8.426 8.426 0 0 1-5.178-1.765h-.014A8.482 8.482 0 0 1 1 9.5Z"
                      />
                    </svg>
                  </div>
                  <div>
                    <div className='text-[14px] text-[#00000099]'>Время заказа</div>
                    <div className='text-black font-semibold text-[18px]'>{order?.createdon}</div>
                  </div>
                </div>
                <div className='flex items-center gap-[8px] mb-[16px] relative z-[2]'>
                  <div className='w-[40px] h-[40px] rounded-full bg-[#eff4ff] flex items-center justify-center flex-none'>
                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={16} fill="none">
                      <path
                        fill="#5A91FF"
                        fillRule="evenodd"
                        d="M.175 5.347c0-.343.278-.621.622-.621h16.581a.622.622 0 0 1 0 1.243H.797a.622.622 0 0 1-.622-.622ZM3.49 11.98c0-.344.279-.622.622-.622H5.77a.622.622 0 1 1 0 1.244H4.112a.622.622 0 0 1-.622-.622ZM7.222 11.98c0-.344.278-.622.621-.622h3.317a.622.622 0 1 1 0 1.244H7.843a.622.622 0 0 1-.621-.622Z"
                        clipRule="evenodd"
                      />
                      <path
                        fill="#5A91FF"
                        fillRule="evenodd"
                        d="M1.97 2.373c-.352.348-.552 1.01-.552 2.469v6.815c0 1.458.2 2.12.552 2.467.354.35 1.03.546 2.506.542H13.698c1.476 0 2.151-.198 2.506-.549.353-.348.552-1.01.552-2.469V4.842c0-1.459-.2-2.12-.553-2.469-.355-.351-1.033-.55-2.514-.55H4.478c-1.477 0-2.152.199-2.507.55Zm-.874-.885C1.846.747 3.011.58 4.478.58h9.21c1.471 0 2.638.167 3.39.908.753.744.922 1.902.922 3.354v6.806c0 1.452-.17 2.61-.922 3.354-.75.741-1.914.908-3.38.908h-9.22c-1.466.004-2.63-.16-3.381-.9-.753-.744-.922-1.902-.922-3.353V4.842c0-1.452.169-2.61.921-3.354Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div>
                    <div className='text-[14px] text-[#00000099]'>Способ оплаты</div>
                    {order?.payment_method == 'online' &&
                      <div className='text-black font-semibold text-[18px]'>Банковской картой {order?.payment_title != null ? `— ${order?.payment_title}` : ``}</div>
                    }
                    {order?.payment_method == 'card' &&
                      <div className='text-black font-semibold text-[18px]'>Картой курьеру</div>
                    }
                    {order?.payment_method == 'cash' &&
                      <div className='text-black font-semibold text-[18px]'>Оплата наличными</div>
                    }
                  </div>
                </div>
                {order?.comment != '' &&
                  <div className='flex items-center gap-[8px] relative z-[2]'>
                    <div className='w-[40px] h-[40px] rounded-full bg-[#eff4ff] flex items-center justify-center flex-none'>
                      <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
                        <path
                          stroke="#5A91FF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m15.391 14.025.325 2.633c.084.692-.658 1.175-1.25.817L10.975 15.4c-.384 0-.759-.025-1.125-.075a4.051 4.051 0 0 0 .983-2.633c0-2.367-2.05-4.284-4.583-4.284-.967 0-1.859.275-2.6.759a5.282 5.282 0 0 1-.034-.634c0-3.791 3.292-6.866 7.359-6.866 4.066 0 7.358 3.075 7.358 6.866 0 2.25-1.159 4.242-2.942 5.492Z"
                        />
                        <path
                          stroke="#5A91FF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M10.834 12.691a4.05 4.05 0 0 1-.984 2.634c-.825 1-2.133 1.642-3.6 1.642l-2.175 1.291c-.366.225-.833-.083-.783-.508l.208-1.642c-1.116-.775-1.833-2.017-1.833-3.417 0-1.466.783-2.758 1.983-3.524a4.736 4.736 0 0 1 2.6-.759c2.534 0 4.584 1.917 4.584 4.284Z"
                        />
                      </svg>
                    </div>
                    <div>
                      <div className='text-[14px] text-[#00000099]'>Комментарий к заказу</div>
                      <div className='text-black font-semibold text-[18px]'>{order?.comment}</div>
                    </div>
                  </div>
                }
              </div>
              <button
                 onClick={() => this.showModal()}
                className="w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#5A91FF] text-white flex items-center justify-between gap-2 border-0 cursor-pointer"
              >
                <div className='w-[30px] h-[30px] rounded-full bg-[#FFFFFF40] flex items-center justify-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
                    <path
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      d="M1.668 1.667h1.45c.9 0 1.608.775 1.533 1.666l-.691 8.3a2.33 2.33 0 0 0 2.325 2.525h8.875c1.2 0 2.25-.983 2.341-2.175l.45-6.25c.1-1.383-.95-2.508-2.341-2.508H4.85M13.542 18.333a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083ZM6.874 18.333a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083ZM7.5 6.667h10"
                    />
                  </svg>
                </div>
                <div className='flex items-center gap-[8px] cursor-pointer'>
                  <div>Посмотреть товары</div>
                  <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="2" cy="2" r="2" fill="white" fill-opacity="0.5"/>
                  </svg>
                  <div>{order?.cart?.total_items} шт</div>
                </div>
                <div className='w-[30px] h-[30px]'></div>
              </button>
              {order?.payment_status == 'pending' &&
                <>
                  <a
                    href={order?.payment_url}
                    className="mt-[10px] w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#F6F6F6] text-black flex items-center justify-between gap-2 no-underline"
                  >
                    <div className='w-[30px] h-[30px] rounded-full bg-[#FFFFFF] flex items-center justify-center'>
                      <svg xmlns="http://www.w3.org/2000/svg" width={18} height={16} fill="none">
                        <path
                          fill="black"
                          fillRule="evenodd"
                          d="M.175 5.347c0-.343.278-.621.622-.621h16.581a.622.622 0 0 1 0 1.243H.797a.622.622 0 0 1-.622-.622ZM3.49 11.98c0-.344.279-.622.622-.622H5.77a.622.622 0 1 1 0 1.244H4.112a.622.622 0 0 1-.622-.622ZM7.222 11.98c0-.344.278-.622.621-.622h3.317a.622.622 0 1 1 0 1.244H7.843a.622.622 0 0 1-.621-.622Z"
                          clipRule="evenodd"
                        />
                        <path
                          fill="black"
                          fillRule="evenodd"
                          d="M1.97 2.373c-.352.348-.552 1.01-.552 2.469v6.815c0 1.458.2 2.12.552 2.467.354.35 1.03.546 2.506.542H13.698c1.476 0 2.151-.198 2.506-.549.353-.348.552-1.01.552-2.469V4.842c0-1.459-.2-2.12-.553-2.469-.355-.351-1.033-.55-2.514-.55H4.478c-1.477 0-2.152.199-2.507.55Zm-.874-.885C1.846.747 3.011.58 4.478.58h9.21c1.471 0 2.638.167 3.39.908.753.744.922 1.902.922 3.354v6.806c0 1.452-.17 2.61-.922 3.354-.75.741-1.914.908-3.38.908h-9.22c-1.466.004-2.63-.16-3.381-.9-.753-.744-.922-1.902-.922-3.353V4.842c0-1.452.169-2.61.921-3.354Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div>Оплатить заказ</div>
                    <div className='w-[30px] h-[30px]'></div>
                  </a>
                  <div className='mt-[10px] text-[16px]'>Не получаеться оплатить онлайн?<br />Повторите заказ с другим способом оплаты</div>
                  <button
                    onClick={() => this.repeatOrder()}
                    className="mt-[10px] w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#F6F6F6] text-black flex items-center justify-between gap-2 border-0 cursor-pointer"
                  >
                    <div className='w-[30px] h-[30px] rounded-full bg-[#FFFFFF] flex items-center justify-center'>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.3346 9.00008C17.3346 13.6001 13.6013 17.3334 9.0013 17.3334C4.4013 17.3334 1.59297 12.7001 1.59297 12.7001M1.59297 12.7001H5.35964M1.59297 12.7001V16.8667M0.667969 9.00008C0.667969 4.40008 4.36797 0.666748 9.0013 0.666748C14.5596 0.666748 17.3346 5.30008 17.3346 5.30008M17.3346 5.30008V1.13341M17.3346 5.30008H13.6346" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <div>Повторить заказ</div>
                    <div className='w-[30px] h-[30px]'></div>
                  </button>
                </>
              }
              {['delivered', 'error', 'cancelled'].includes(status) &&
                <button
                  onClick={() => this.repeatOrder()}
                  className="mt-[10px] w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#F6F6F6] text-black flex items-center justify-between gap-2 border-0 cursor-pointer"
                >
                  <div className='w-[30px] h-[30px] rounded-full bg-[#FFFFFF] flex items-center justify-center'>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.3346 9.00008C17.3346 13.6001 13.6013 17.3334 9.0013 17.3334C4.4013 17.3334 1.59297 12.7001 1.59297 12.7001M1.59297 12.7001H5.35964M1.59297 12.7001V16.8667M0.667969 9.00008C0.667969 4.40008 4.36797 0.666748 9.0013 0.666748C14.5596 0.666748 17.3346 5.30008 17.3346 5.30008M17.3346 5.30008V1.13341M17.3346 5.30008H13.6346" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>Повторить заказ</div>
                  <div className='w-[30px] h-[30px]'></div>
                </button>
              }
            </div>
          </div>
        </div>
        {modal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => this.closeModal()}></div>
            <div className="relative bg-white rounded-[25px] w-full max-w-lg max-h-[80vh] overflow-y-auto p-6 shadow-xl">
              <div className="flex items-center justify-between mb-4">
                <div className="text-[18px] font-semibold">Заказ №{order?.number}</div>
                <button onClick={() => this.closeModal()} className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center border-0 cursor-pointer">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 13L13 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M13 13L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                </button>
              </div>
          {order?.cart?.items.map((item, k) => (
            <div key={k} className="mb-[20px] pb-[15px] border-b border-gray-200 last:border-b-0">
              <div className='flex justify-between items-end gap-[5px] w-100 mb-[10px]'>
                <div className="font-medium">{item?.pagetitle}</div>
                <div className='border-t-[1px] border-dashed border-[#0000004D] flex-1' />
                <div>{item?.quantity}шт.</div>
              </div>
              
              {item?.ingredients && item.ingredients.filter( ing => !ing.anti ).length > 0 && (
                <div className="pl-[15px]">
                  <div className="text-sm text-gray-500 mb-[8px]">Доп. ингредиенты:</div>
                  {item.ingredients.filter( ing => !ing.anti ).map((ingredient, index) => (
                    <div key={index} className="flex justify-between text-sm mb-[5px]">
                      <span>{ingredient.name}</span>
                      <span className="text-gray-600">{ingredient.count}шт.</span>
                    </div>
                  ))}
                </div>
              )}
              {item?.ingredients && item.ingredients.filter( ing => ing.anti ).length > 0 && (
                <div className="pl-[15px]">
                  <div className="text-sm text-gray-500 mb-[8px]">Убрать:</div>
                  <div className="text-sm">{item.ingredients.filter( ing => ing.anti ).map( ing => ing.name ).join(', ')}</div>
                </div>
              )}
            </div>
          ))}
          {order?.cart?.extras.map((item, k) => (
            <div key={k} className="mb-[20px] pb-[15px] border-b border-gray-200 last:border-b-0">
              <div className='flex justify-between items-end gap-[5px] w-100 mb-[10px]'>
                <div className="font-medium">{item?.pagetitle}</div>
                <div className='border-t-[1px] border-dashed border-[#0000004D] flex-1' />
                <div>{item?.quantity}шт.</div>
              </div>
            </div>
          ))}
          {order?.cart?.gifts.map((item, k) => (
            <div key={k} className="mb-[20px] pb-[15px] border-b border-gray-200 last:border-b-0">
              <div className='flex justify-between items-end gap-[5px] w-100 mb-[10px]'>
                <div className="font-medium">{item?.pagetitle}</div>
                <div className='border-t-[1px] border-dashed border-[#0000004D] flex-1' />
                <div>{item?.quantity}шт.</div>
              </div>
            </div>
          ))}
          <div className="mb-[20px] pb-[15px] border-b border-gray-200 last:border-b-0">
            <div className='flex justify-between items-end gap-[5px] w-100 mb-[10px]'>
              <div className="font-medium">Итого</div>
              <div className='border-t-[1px] border-dashed border-[#0000004D] flex-1' />
              <div>{order?.final_amount} ₽</div>
            </div>
          </div>
            </div>
          </div>
        )}
      </>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string,
  order: PropTypes.object,
  user: PropTypes.object,
  restaurant: PropTypes.object
}

export default Main